import { NgModule } from '@angular/core';
import { CommonModule } from '@angular/common';
import { FilterTablePipe } from './filter-table.pipe';
import { SearchPipe } from './filter.pipe';
import { SearchClientPipe } from './filterClient.pipe';
import { SortPipe } from './orderBy.pipe';

@NgModule({
	declarations: [FilterTablePipe, SearchPipe, SearchClientPipe, SortPipe],
	imports: [CommonModule],
	exports: [FilterTablePipe, SearchPipe, SearchClientPipe, SortPipe],
})
export class PipesModule { }
